import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

export interface RecipesSiteAssignmentDto {
	assignments: RecipeSiteAssignmentDto[];
}

export interface RecipeSiteAssignmentDto {
	recipeId: string;
	recipeName: string;
	assigned: boolean;
}

const useGetRecipesSiteAssignment = (siteId: string, options?: QueryOptions<RecipesSiteAssignmentDto>) => { 
  const user = useUser();

  return useUserQuery<RecipesSiteAssignmentDto>(
    { path: `/api/businesses/${user.selectedBusiness?.id!}/sites/${siteId}/recipesAssignment` },
    options);
}

export default useGetRecipesSiteAssignment;
